<template>
  <div>
    <!-- Header skeleton -->
    <div class="flex items-center justify-between mb-6">
      <div class="flex items-center gap-2.5">
        <skeleton width="120px" height="28px"></skeleton>
        <skeleton width="32px" height="24px" rounded="50px"></skeleton>
      </div>
      <skeleton width="140px" height="36px" rounded="50px"></skeleton>
    </div>

    <!-- Toolbar skeleton -->
    <div class="flex items-center justify-between gap-4 mb-5">
      <skeleton width="320px" height="40px" rounded="10px"></skeleton>
      <div class="flex items-center gap-2">
        <skeleton width="120px" height="36px" rounded="8px"></skeleton>
        <skeleton width="200px" height="36px" rounded="8px"></skeleton>
      </div>
    </div>

    <!-- Card skeletons -->
    <div class="flex flex-col gap-1">
      <div v-for="i in 6" :key="i" class="flex items-center gap-4 bg-white border border-border rounded-[16px] px-5 py-3.5">
        <skeleton width="40px" height="40px" rounded="50%"></skeleton>
        <div class="flex-1 flex flex-col gap-2">
          <skeleton width="140px" height="16px"></skeleton>
          <skeleton width="100px" height="13px"></skeleton>
        </div>
        <skeleton width="55px" height="22px" rounded="4px" class-name="max-lg:hidden"></skeleton>
        <div class="flex items-center gap-2 w-[140px] max-lg:w-[100px]">
          <skeleton width="100%" height="6px" rounded="3px"></skeleton>
          <skeleton width="28px" height="14px"></skeleton>
        </div>
        <skeleton width="80px" height="14px"></skeleton>
        <skeleton width="64px" height="32px" rounded="50%" class-name="max-lg:hidden"></skeleton>
      </div>
    </div>
  </div>
</template>

<script>
import Skeleton from './Skeleton'

export default {
  name: 'SkeletonApplicantList',
  components: { Skeleton }
}
</script>
